export default __webpack_public_path__ + "static/media/login-image.dd4dc963.png";